// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"987be27d","247":"5b7348eb","284":"ea93e8f2","330":"395c8c73","350":"bb7322ea","453":"cea4e896","618":"040a6233","627":"5cbece00","728":"f6e47309","867":"a53db872","923":"efd379cc","938":"4f354ce2"}[chunkId] + ".chunk.js";
};